import * as React from "react";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AdviceGivenQuestionText } from "../Resource/Contents";
import { SectionHeader } from "../SharedComponents";
interface IFinancialAdviceProps extends IProcessComponentProps {}

interface IFinancialAdviceState {}

export class FinancialAdvice extends ProcessComponent<IFinancialAdviceProps, IFinancialAdviceState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                {SectionHeader("Financial advice")}
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-150 mb-23"
                    selected={data?.AdviceGiven}
                    options={[true, false]}
                    label={AdviceGivenQuestionText}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) =>
                        this.onDataChange(
                            onChange,
                            {
                                AdviceGiven: v,
                            },
                            data
                        )
                    }
                    required="Please select"
                    validationRules={[
                        {
                            errorMessage: "To continue, you must have given financial advice.",
                            validator: (v) => {
                                return v == null ? true : v;
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
